import { getInsuranceNamesForCard } from 'app/ProviderDetails/AcceptedInsurance/useInsuranceSplit'
import { carrierInsuranceMatcherConfig } from 'app/ProviderDetails/AcceptedInsurance/helpers'
import {
  CARD_LIST_MORE_TEXT,
  CARD_LIST_VISIBLE_COUNT,
} from 'app/ProviderSearch/constants'

export const renderInsuranceSection = (
  insuranceName: string,
  providerInsurances: string[],
  insuranceNamesValues: string[]
): JSX.Element => {
  const hasMatch = insuranceName && providerInsurances?.includes(insuranceName)

  if (!hasMatch) {
    return <>{insuranceNamesValues.join(', ')}</>
  }

  // Has match - move matching insurance to first position
  const matchingName =
    providerInsurances.find(
      (name: string) =>
        name.toLowerCase().trim() === insuranceName.toLowerCase().trim()
    ) || insuranceName

  // the searched plan comes first as its carrier's entry, under its own name
  // rather than the carrier's, and the rest of the plans are grouped as usual
  const [, ...otherInsurances] = getInsuranceNamesForCard(
    providerInsurances.map((name) => ({
      insuranceProvider: { id: name, name },
    })),
    carrierInsuranceMatcherConfig,
    matchingName
  )
  const reorderedInsurances = [matchingName, ...otherInsurances]

  // Common rendering function
  const renderInsurances = (insurances: string[]) =>
    insurances.map((name, index) => (
      <span key={index}>
        {name === matchingName ? (
          <span className="~font-semibold">{name}</span>
        ) : (
          name
        )}
        {index < insurances.length - 1 ? ', ' : ''}
      </span>
    ))

  const shouldTruncate = reorderedInsurances.length > CARD_LIST_VISIBLE_COUNT
  const visibleInsurances = shouldTruncate
    ? reorderedInsurances.slice(0, CARD_LIST_VISIBLE_COUNT)
    : reorderedInsurances

  return (
    <span>
      {renderInsurances(visibleInsurances)}
      {shouldTruncate && `, ${CARD_LIST_MORE_TEXT}`}
    </span>
  )
}

export const renderSpecialtySection = (
  selectedSpecialtyNames: string[],
  allAreasOfConcernValues: string[],
  areaOfConcernValues: string[],
  providerAreasOfConcerns: string[]
): JSX.Element => {
  const hasMatch =
    selectedSpecialtyNames.length > 0 &&
    selectedSpecialtyNames.some((name) =>
      allAreasOfConcernValues.includes(name)
    )

  if (!hasMatch) {
    return <>{areaOfConcernValues.join(', ')}</>
  }

  // Has match - move matching specialties to first position
  const matchingSpecialties = allAreasOfConcernValues.filter((name) =>
    selectedSpecialtyNames.includes(name)
  )
  const otherSpecialties = allAreasOfConcernValues.filter(
    (name) => !selectedSpecialtyNames.includes(name)
  )
  const reorderedSpecialties = [...matchingSpecialties, ...otherSpecialties]

  const renderSpecialties = (specialties: string[]) =>
    specialties.map((name, index) => (
      <span key={index}>
        {selectedSpecialtyNames.includes(name) ? (
          <span className="~font-semibold">{name}</span>
        ) : (
          name
        )}
        {index < specialties.length - 1 ? ', ' : ''}
      </span>
    ))

  const shouldTruncate =
    providerAreasOfConcerns.length > CARD_LIST_VISIBLE_COUNT
  const visibleSpecialties = shouldTruncate
    ? reorderedSpecialties.slice(0, CARD_LIST_VISIBLE_COUNT)
    : reorderedSpecialties

  return (
    <span>
      {renderSpecialties(visibleSpecialties)}
      {shouldTruncate && `, ${CARD_LIST_MORE_TEXT}`}
    </span>
  )
}
